import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
//import firebase from 'firebase/compat';
import { useAuth } from '../contextos/AuthProvider.jsx';
import '../Estilos/LoginForm.css';
import '../Estilos/EstiloSap.css';
import '../Estilos/Principal.css';
import Cloud from '../New Template/images/LogoPcService.png'
import ResetPassword from './ResetPassword.jsx';
const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const { signIn, ObtenerToken } = useAuth();
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    //firebase.auth().signInWithEmailAndPassword(email, password)

    await signIn(email, password).then(() => {
      ObtenerToken();
      navigate('/');
    }).catch((error) => {
      setError(error.message)
    });





  };

  return (
    <>
      <div className="contenedor">
        <div className='tituloPantalla' style={{ width: '100%', padding: '0px', marginLeft: '0px' }}>
          <p style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}>SmartFE</p>
        </div>
        <form onSubmit={handleLogin}>
          <div className='row'>
            <div className='col-md-4' style={{ padding: '0' }}>
              <img src={Cloud} style={{ width: '100%', position: 'relative', top: '10%', transform: 'translateY(-50%)' }} alt='Logo Cloud'></img>
            </div>
            <div className='col-md-8'>
              <div className='elemento'>
                <label>Correo:
                  <input type="text" value={email} onChange={(event) => setEmail(event.target.value)} />
                </label>
              </div>
              <div className='elemento'>
                <label>Contraseña:
                  <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} style={{ padding: '5px' }} />
                </label>
              </div>
              <div className='elemento'>
                <div className='botones-login'>
                  <button id='BtndelLogin' name='BtndelLogin' type="submit">Ingresar</button>
                  <ResetPassword />
                </div>
                {error && <p>{error}</p>}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default LoginForm;